<template>
    <div>
        <FullscreenLoading v-if="isLoading" />

        <div class="row mt-3">
            <div class="col-12">
                <div class="card">
                    <div class="card-header pb-3" v-if="!embed">
                        <div class="d-flex justify-content-between align-items-center">
                            <span class="h4">{{ $t('emailtemplate.title') }}</span>
                        </div>
                    </div>
                    <div class="card-body">
                        <table class="table table-sm table-no-side-paddings table-striped">
                            <thead>
                                <tr>
                                    <Ordering @change="load()" v-model="order" field="type" tag="th">
                                        {{ $t('general.name') }}
                                    </Ordering>
                                    <Ordering @change="load()" v-model="order" field="subject" tag="th">
                                        {{ $t('general.subject') }}
                                    </Ordering>
                                    <th />
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <td>
                                        <input
                                            @change="load(1)"
                                            class="form-control form-control-filtering"
                                            type="text"
                                            v-model="filtering.type"
                                            :placeholder="$t('emailtemplate.search_name')"
                                        />
                                    </td>
                                    <td>
                                        <input
                                            @change="load(1)"
                                            class="form-control form-control-filtering"
                                            type="text"
                                            v-model="filtering.subject"
                                            :placeholder="$t('emailtemplate.search_subject')"
                                        />
                                    </td>
                                    <td />
                                </tr>

                                <tr v-for="emailTemplate of emailTemplates.data" :key="emailTemplate.type">
                                    <td>{{ emailTemplate.type }}</td>
                                    <td>{{ emailTemplate.subject }}</td>
                                    <td class="text-right">
                                        <RouterLink :to="{ name: 'email_template', params: { type: emailTemplate.type } }">
                                            <button class="btn btn-xs btn-primary">
                                                {{ $t('general.edit') }}
                                            </button>
                                        </RouterLink>
                                    </td>
                                </tr>

                                <tr v-if="emailTemplates.data.length === 0 && !isLoading">
                                    <td colspan="3" class="no-results">{{ $t('emailtemplate.no_results') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-footer border-0">
                        <Pagination :pagination="emailTemplates" @change="load" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

    import { computed, inject, onMounted, ref } from 'vue';
    import Pagination from '../../components/Pagination';
    import FullscreenLoading from '../../components/FullscreenLoading';
    import Ordering from '../../components/Ordering';
    import { notifyError } from '../../utils/notify';

    const http = inject('http');

    const isLoading = ref(false);
    const emailTemplates = ref({
        current_page: 1,
        data: [],
    });

    const order = ref('type,desc');
    const filtering = ref({
        type: null,
        subject: null,
    });

    const embed = computed(() => {
        return window.location.search.includes('embed=true');
    });

    onMounted(() => {
        load(1);
    });

    async function load(page = undefined) {
        isLoading.value = true;

        try {
            const response = await http.get('/api/email-templates', {
                params: {
                    page: page || emailTemplates.value.current_page,
                    order: order.value,
                    // todo: refactor when updated to vue3
                    'filters[type]': filtering.value.type,
                    'filters[subject]': filtering.value.subject,
                },
            });

            emailTemplates.value = response.data;
        } catch (exception) {
            notifyError(exception);
        }

        isLoading.value = false;
    }

</script>
